import React from "react";
import Styles from "../ConnectionAcceptModal/ConnectionAcceptModal.module.css";
import { CircularProgress, Modal } from "@mui/material";
import { ReactComponent as ErrorIcon } from "../../../../assets/images/release.svg";

const ReleasePop = ({ open, handleClose, onConfirm, loading = false }) => {
  return (
    <Modal
      open={open}
      onClose={!loading ? handleClose : undefined} // 🚫 block close while loading
    >
      <div
        className={`${Styles.createEditModalCont} ${Styles.createEditWithdrawModalCont}`}
      >
        <div className={`headingText ${Styles.withdrawText}`}>Release</div>

        <div className={`${Styles.headerSection} ${Styles.withdrawSection}`}>
          <ErrorIcon style={{ width: "50px", height: "50px" }} />

          <div className={Styles.releaseHead}>
            <span>
              Do you want to <span style={{ fontWeight: "500" }}>release</span>{" "}
              this
            </span>
            <span>listing?</span>
          </div>
        </div>

        <div className={Styles.buttonSection}>
          {/* NO */}
          <div
            onClick={!loading ? handleClose : undefined}
            className={loading ? Styles.disabledBtn : ""}
          >
            <span className={Styles.onHoverButton}>
              {/* {loading ? <CircularProgress size={18} /> : "No"} */}
              No
            </span>
          </div>

          {/* YES */}
          <div
            onClick={!loading ? onConfirm : undefined}
            className={loading ? Styles.disabledBtn : ""}
          >
            <span
              className={Styles.onHoverButton}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              {loading ? (
                <>
                  <span>Processing...</span>
                </>
              ) : (
                "Yes"
              )}
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ReleasePop;
